import { EntityApiService, ApiClientService } from "@dfl/react-security";

class ImageService extends EntityApiService<any> {
	upload = (image: any) => {
		return this.handleResponse(ApiClientService.post(this.getPath(""), image));
	};
}

export default new ImageService("/ms-auth/api/files/image");
